var React = require('react');

function InstagramInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.193 0H4.647A4.653 4.653 0 000 4.647v7.546a4.653 4.653 0 004.647 4.647h7.546a4.653 4.653 0 004.648-4.647V4.647A4.653 4.653 0 0012.193 0zm3.153 12.193a3.157 3.157 0 01-3.153 3.153H4.647a3.157 3.157 0 01-3.153-3.153V4.647a3.157 3.157 0 013.153-3.153h7.546a3.157 3.157 0 013.153 3.153v7.546z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8.42 4.081a4.339 4.339 0 104.339 4.339A4.344 4.344 0 008.42 4.081zm0 7.184a2.845 2.845 0 112.845-2.845 2.848 2.848 0 01-2.845 2.845z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M12.942 2.814a1.1 1.1 0 10.775.321 1.1 1.1 0 00-.775-.321z","fill":"currentColor","key":2})]);
}

InstagramInline.defaultProps = {"viewBox":"0 0 16.841 16.841"};

module.exports = InstagramInline;

InstagramInline.default = InstagramInline;
